import { useQuery } from '@tanstack/react-query';

import { fetchProductAttributes } from './api';
import { toProductAttributes } from './helpers';

import { RQ_PRODUCT_ATTRIBUTES_KEY } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';

export function useProductAttributes({ enabled = true } = {}) {
  const { language } = useCurrentLanguage();

  return useQuery({
    enabled,
    queryKey: [RQ_PRODUCT_ATTRIBUTES_KEY, language],
    queryFn: async () => {
      const result = await fetchProductAttributes();
      const data = result?.data;

      if (
        !data?.age ||
        !data?.colour?.attributes ||
        !data?.condition?.attributes ||
        !data?.source ||
        !data?.style
      ) {
        throw new Error(
          'Product attributes response is missing a required group'
        );
      }

      return toProductAttributes(data, language);
    },
    refetchOnMount: false,
  });
}
